import { createApp } from 'vue'
import 'virtual:svg-icons-register'

import { setupStore } from '@/store'

import GlobalHeader from '@/components/desktop/GlobalHeader/index.vue'
import GlobalShare from '@/components/desktop/GlobalShare/index.vue'
import FooterSiteMap from '@/components/desktop/GlobalFooter/FooterSiteMap.vue'
import FooterShare from '@/components/desktop/GlobalFooter/FooterShare.vue'

import '@/core'

import 'uno.css'

import '@/views/article/desktop/global.less'

const globalHeader = createApp(GlobalHeader)
const globalShare = createApp(GlobalShare)
const footerSiteMap = createApp(FooterSiteMap)
const footerShare = createApp(FooterShare)

function render(props: any, App: any) {
  // 判断是不是qiankun的
  const { container } = props

  // 配置store
  setupStore(App)

  App.mount(
    typeof container === 'string' ? container : (container.querySelector('#app') as Element)
  )
}

const sections = [
  ['#globalHeader', globalHeader],
  ['#globalShare', globalShare],
  ['#footerSitemap', footerSiteMap],
  ['#footerShare', footerShare],
];

sections.forEach(([container, content]) => render({ container }, content));

